<div class="flex items-center gap-x-2">

    <app-button
        #benefitsButton
        [custom]="['benefits-glow']"
        [disabled]="benefits.isAnimating()"
        [label]="'Benefits'"
        [active]="benefits.showContainer()"
        [hidden]="!benefits.showButton()"
        (event)="benefits.toggleContainer()"
    />

</div>